import { render } from "./SsoApps.vue?vue&type=template&id=a83f83d0&scoped=true"
import script from "./SsoApps.vue?vue&type=script&lang=js"
export * from "./SsoApps.vue?vue&type=script&lang=js"

import "./SsoApps.vue?vue&type=style&index=0&id=a83f83d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-dilatih/frontend-dilatih/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a83f83d0"]])

export default __exports__